import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import "@/App.css";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Security from "@/pages/Security";
import Contact from "@/pages/Contact";
import CaseIntake from "@/pages/CaseIntake";
import Login from "@/pages/Login";

import PortalShell from "@/components/PortalShell";
import Dashboard from "@/pages/portal/Dashboard";
import Cases from "@/pages/portal/Cases";
import CaseDetail from "@/pages/portal/CaseDetail";
import Invoices from "@/pages/portal/Invoices";
import AuditLog from "@/pages/portal/AuditLog";
import Intakes from "@/pages/portal/Intakes";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/security" element={<Security />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/case-intake" element={<CaseIntake />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/portal" element={<Protected><PortalShell /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="cases" element={<Cases />} />
            <Route path="cases/:id" element={<CaseDetail />} />
            <Route path="intakes" element={<Intakes />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="audit" element={<AuditLog />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
